
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import GroomingPageFeature from '../components/GroomingPageFeature'
import BreadCrumb from '../components/BreadCrumb'
import DogGroomingPagePrice from '../components/DogGroomingPagePrice'
import { Helmet } from 'react-helmet'
import ScrollNavbar from '../components/ScrollNavbar'
import CustomerFeedback from '../components/main/CustomerFeedback'

const DogGroomingPage = () => {
  return (
    <div>


<Helmet>
        <title>Professional Dog Grooming at Home | FluffyTouch</title>
        <meta
          name="description"
          content="Book expert at-home dog grooming! Bath, haircut & nail trim in your home. Certified groomers, same-day slots & 30% OFF first booking. Call now!"
        />
      </Helmet>

      <ScrollNavbar/>
        
        
        <Navbar/>
        <BreadCrumb name="Dog Grooming" title="Best Dog Grooming Services At Home"/>

<DogGroomingPagePrice/>

        <GroomingPageFeature/>

        <div className='ft-customer-rev-of-get-grooming-page'>

        <CustomerFeedback viewMoreValue="active" />
        </div>

        <Footer/>
        
    </div>
  )
}

export default DogGroomingPage